import { useState } from "react";
import { useSelector } from "react-redux";
import { EPulseContainer, EPulseChartAnimated } from "@components";
import { selectEPulseData } from "@store/selectors/meetingSelectors";
import { calculateEngagementLevel } from "@utils/ePulseHelpers";

const EPulse = ({
  agenda,
  isMinimized: controlledIsMinimized,
  onMinimizeChange,
}) => {
  const [uncontrolledIsMinimized, setUncontrolledIsMinimized] = useState(false);
  const ePulseData = useSelector(selectEPulseData);

  const isControlled = controlledIsMinimized !== undefined;
  const isMinimized = isControlled
    ? controlledIsMinimized
    : uncontrolledIsMinimized;

  const defaultEpulse = [];
  const currentEPulseData = agenda.live ? ePulseData : defaultEpulse;
  const currentEngagementLevel = calculateEngagementLevel(currentEPulseData);

  const handleToggleMinimize = () => {
    const newValue = !isMinimized;
    if (!isControlled) {
      setUncontrolledIsMinimized(newValue);
    }
    onMinimizeChange?.(newValue);
  };

  return (
    <EPulseContainer
      agenda={agenda}
      isMinimized={isMinimized}
      onToggleMinimize={handleToggleMinimize}
      currentEngagementLevel={currentEngagementLevel}
    >
      <EPulseChartAnimated agenda={agenda} animationType="heartbeat" />
    </EPulseContainer>
  );
};

export default EPulse;
